var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.isIndex ? 'h2' : 'h1',{tag:"component",staticClass:"seo-only"},[_vm._v("聯絡佑昇生殖中心與門診資訊")]),_c('OutPatientTime'),_c('TrafficInfomation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }